export const serverPrefix = '/api/front';
export const serverAuthPrefix = '/api/auth';
export const serverKerbPrefix = '/api';

const serverRoutes = {
  me: `${serverPrefix}/me`,
  login: `${serverAuthPrefix}/login`,
  allChats: `${serverPrefix}/chat/bulk`,
  singleChat: `${serverPrefix}/chat`,
  chatGroup: `${serverPrefix}/c_project/group/bulk`,
  newChatGroup: `${serverPrefix}/c_project/group`,
  chatProject: `${serverPrefix}/c_project`,
  chatPreset: `${serverPrefix}/c_project/preset`,
  manualRecordingUpload: `${serverPrefix}/record`,
  changeAnalyticChatStatus: `${serverPrefix}/c_project/status/change`,
  getAnalyticChatStatus: `${serverPrefix}/c_project/status`,
  refresh_token: `${serverAuthPrefix}/refresh`,
  recordMetadata: `${serverPrefix}/record/metadata`,
  tenantAliases: `${serverPrefix}/alias/bulk`,
  aliases: `${serverPrefix}/cus/aliases`,
  c_aliases: `${serverPrefix}/cus/c/aliases`,
  preset: `${serverPrefix}/preset`,
  usersBulk: `${serverPrefix}/adm/user/bulk`,
  usersShortBulk: `${serverPrefix}/adm/user/bulk/short`,
  users: `${serverPrefix}/adm/user`,
  userGroupsBulk: `${serverPrefix}/adm/group/bulk`,
  userGroups: `${serverPrefix}/adm/group`,
  addUserToGroup: `${serverPrefix}/adm/group/user/add`,
  removeUserFromGroup: `${serverPrefix}/adm/group/user/remove`,
  usersRole: `${serverPrefix}/adm/role/bulk`,
  projectInfo: `${serverPrefix}/project`,
  projectMetricResult: `${serverPrefix}/project/metric_result`,
  projectChatMetricResult: `${serverPrefix}/c_project/metric_result`,
  projectMetric: `${serverPrefix}/project/metric`,
  projectMetricValue: `${serverPrefix}/project/metric/value`,
  chatProjectMetricValue: `${serverPrefix}/c_project/metric/value`,
  metrics: `${serverPrefix}/project/metric_result/bulk`,
  metricsChat: `${serverPrefix}/c_project/metric_result/bulk`,
  recordList: `${serverPrefix}/record/bulk`,
  record: `${serverPrefix}/record`,
  downloadRecordTranscription: `${serverPrefix}/record/transcription/export`,
  downloadChatRecordTranscription: `${serverPrefix}/chat/transcription/export`,
  audio: `${serverPrefix}/record/audio`,
  reports: `${serverPrefix}/project/report/bulk`,
  changeStatus: `${serverPrefix}/project/report/status`,
  report: `${serverPrefix}/project/report`,
  live_reports: `${serverPrefix}/live_report/bulk`,
  chat_live_reports: `${serverPrefix}/c_live_report/bulk`,
  live_report: `${serverPrefix}/live_report`,
  chat_live_report: `${serverPrefix}/c_live_report`,
  live_report_clone: `${serverPrefix}/live_report/clone`,
  chat_live_report_clone: `${serverPrefix}/c_live_report/clone`,
  live_report_export: `${serverPrefix}/live_report/record/export`,
  live_report_records: `${serverPrefix}/live_report/record/bulk`,
  chat_live_report_records: `${serverPrefix}/c_live_report/chat/bulk`,
  projects: `${serverPrefix}/project/bulk`,
  projectsChat: `${serverPrefix}/c_project/bulk`,
  charts: `${serverPrefix}/live_report/graph/bulk`,
  chatCharts: `${serverPrefix}/c_live_report/graph/bulk`,
  chartData: `${serverPrefix}/live_report/graph/data`,
  chatChartData: `${serverPrefix}/c_live_report/graph/data`,
  chart: `${serverPrefix}/live_report/graph`,
  chatChart: `${serverPrefix}/c_live_report/graph`,
  chartLayout: `${serverPrefix}/live_report/graph/layout`,
  chatChartLayout: `${serverPrefix}/c_live_report/graph/layout`,
  metric: `${serverPrefix}/project/metric/bulk`,
  metricChat: `${serverPrefix}/c_project/metric/bulk`,
  metricProjectChat: `${serverPrefix}/c_project/metric`,
  metricProject: `${serverPrefix}/project/metric`,
  metricProjectBatch: `${serverPrefix}/project/metric/batch`,
  metricChatProjectBatch: `${serverPrefix}/c_project/metric/batch`,
  transcription: `${serverPrefix}/record/transcription`,
  recordTranscriptionModels: `${serverPrefix}/record/transcriptions`,
  audioChannel: `${serverPrefix}/settings/channel`,
  audioChannels: `${serverPrefix}/settings/channel/bulk`,
  userInfo: `${serverPrefix}/me`,
  wordsCloud: `${serverPrefix}/wordcloud`,
  audit_logs: `${serverPrefix}/audit_log/bulk`,
  audit_log: `${serverPrefix}/audit_log`,
  commonSettingsChannels: `${serverPrefix}/settings/channel/bulk`,
  commonSettingChannel: `${serverPrefix}/settings/channel`,
  aliasSettings: `${serverPrefix}/alias/bulk`,
  aliasSetting: `${serverPrefix}/alias`,
  aliasSettingUsage: `${serverPrefix}/alias/usage`,
  aliasQmSettings: `${serverPrefix}/settings/qm/op_meta`,
  recognition_rule_default: `${serverPrefix}/recog_rule/default`,
  recognition_rule: `${serverPrefix}/recog_rule`,
  recognition_rule_do: `${serverPrefix}/recog_rule/do`,
  recognition_rule_count: `${serverPrefix}/recog_queue/count`,
  recognition_rules: `${serverPrefix}/recog_rule/bulk`,
  asr_models: `${serverPrefix}/usr/model/bulk`,
  asr_ext_models: `${serverPrefix}/ext_asr_model/bulk`,
  asr_model: `${serverPrefix}/usr/model`,
  dashboards: `${serverPrefix}/dashboard/bulk`,
  dashboard: `${serverPrefix}/dashboard`,
  dashboardTake: `${serverPrefix}/dashboard/take`,
  dashboardGraphs: `${serverPrefix}/dashboard/graph/bulk`,
  dashboardGraph: `${serverPrefix}/dashboard/graph`,
  dashboardLayout: `${serverPrefix}/dashboard/graph/layout`,
  analyticsProjectsGroups: `${serverPrefix}/project/group/bulk`,
  analyticsProjectsGroup: `${serverPrefix}/project/group`,
  analyticsProjectsGroupsStatus: `${serverPrefix}/project/status/bulk`,
  analyticsProjectStatus: `${serverPrefix}/project/status`,
  analyticsProject: `${serverPrefix}/project`,
  analyticsProjectTake: `${serverPrefix}/project/take`,
  analyticsChatProjectTake: `${serverPrefix}/c_project/take`,
  analyticsProjectPreset: `${serverPrefix}/project/preset`,
  analyticsChatProjectPreset: `${serverPrefix}/c_project/preset`,
  analyticsProjectStatusChange: `${serverPrefix}/project/status/change`,
  presetGroups: `${serverPrefix}/preset_group/bulk`,
  presetGroup: `${serverPrefix}/preset_group`,
  metricTemplatesGroups: `${serverPrefix}/metric_template/group/bulk`,
  metricTemplatesGroup: `${serverPrefix}/metric_template/group`,
  metricTemplate: `${serverPrefix}/metric_template`,
  metricsTypes: `${serverPrefix}/metric_types/bulk`,
  chatMetricsTypes: `${serverPrefix}/chat_metric_types/bulk`,
  metricsClassifierModels: `${serverPrefix}/classifier/models`,
  metricsClassifierSecondModels: `${serverPrefix}/classifier2/models`,
  dictionaries: `${serverPrefix}/dictionary/bulk`,
  dictionary: `${serverPrefix}/dictionary`,
  dictionary_export: `${serverPrefix}/dictionary/export`,
  dictionary_import: `${serverPrefix}/dictionary/import`,
  integrationsAccessKeys: `${serverPrefix}/access_key/bulk`,
  integrationsAccessKey: `${serverPrefix}/access_key`,
  gramCloud: `${serverPrefix}/ngramcloud`,
  gramCloudUpdate: `${serverPrefix}/ngramcloud/update`,
  gramCloudStatus: `${serverPrefix}/ngramcloud/status`,
  gramCloudData: `${serverPrefix}/ngramcloud/data`,
  gramCloudChat: `${serverPrefix}/c_ngramcloud`,
  gramCloudUpdateChat: `${serverPrefix}/c_ngramcloud/update`,
  gramCloudStatusChat: `${serverPrefix}/c_ngramcloud/status`,
  gramCloudDataChat: `${serverPrefix}/c_ngramcloud/data`,
  userSettings: `${serverPrefix}/cus/parameters`,
  billing: `${serverPrefix}/billing`,
  emailMessages: `${serverPrefix}/sender/email_queue/bulk`,
  telegramMessages: `${serverPrefix}/sender/telegram_queue/bulk`,
  telegramTenantRecipients: `${serverPrefix}/sender/telegram/recipient/bulk`,
  emailTenantRecipients: `${serverPrefix}/sender/email/recipient/bulk`,
  metricTriggerBulk: `${serverPrefix}/project/trigger/bulk`,
  metricTrigger: `${serverPrefix}/project/trigger`,
  triggerEmailRecipientNew: `${serverPrefix}/project/trigger/email_recipient/new`,
  triggerTelegramRecipientNew: `${serverPrefix}/project/trigger/telegram_recipient/new`,
  triggerEmailRecipientsBulk: `${serverPrefix}/project/trigger/email_recipient/bulk`,
  triggerTelegramRecipientsBulk: `${serverPrefix}/project/trigger/telegram_recipient/bulk`,
  triggerEmailRecipient: `${serverPrefix}/project/trigger/email_recipient`,
  triggerTelegramRecipient: `${serverPrefix}/project/trigger/telegram_recipient`,
  emailTenantRecipient: `${serverPrefix}/sender/email/recipient`,
  telegramTenantRecipient: `${serverPrefix}/sender/telegram/recipient`,
  reportTasksBulk: `${serverPrefix}/live_report/report_task/bulk`,
  reportTasks: `${serverPrefix}/live_report/report_task`,
  reportTasksEmailRecipientsBulk: `${serverPrefix}/live_report/report_task/email_recipient/bulk`,
  reportTasksTgRecipientsBulk: `${serverPrefix}/live_report/report_task/telegram_recipient/bulk`,
  reportTelegramRecipientNew: `${serverPrefix}/live_report/report_task/telegram_recipient/new`,
  reportEmailRecipientNew: `${serverPrefix}/live_report/report_task/email_recipient/new`,
  reportTelegramRecipient: `${serverPrefix}/live_report/report_task/telegram_recipient`,
  reportEmailRecipient: `${serverPrefix}/live_report/report_task/email_recipient`,
  static_report: `${serverPrefix}/static_report`,
  c_role_settings_bulk: `${serverPrefix}/settings/c_role/bulk`,
  c_role_settings: `${serverPrefix}/settings/c_role`,
  full_text_search: `${serverPrefix}/record/search`,
  full_text_search_by_project: `${serverPrefix}/project/search`,
  full_text_search_by_project_live_reports_only: `${serverPrefix}/live_report/search`,
  full_text_search_chat: `${serverPrefix}/chat/search`,
  full_text_search_by_chat_project: `${serverPrefix}/c_project/search`,
  full_text_search_by_chat_project_live_reports_only: `${serverPrefix}/c_live_report/search`,
  rtk_block: `${serverPrefix}/rtk_block`,
  qm_manage_commands_bulk: `${serverPrefix}/qm/team/bulk`,
  qm_manage_commands: `${serverPrefix}/qm/team`,
  qm_manage_commands_operator_bulk: `${serverPrefix}/qm/team/operator/bulk`,
  qm_manage_commands_operator: `${serverPrefix}/qm/team/operator`,
  qm_manage_commands_status: `${serverPrefix}/qm/team/status`,
  qm_users_with_roles_bulk: `${serverPrefix}/adm/qm/user/bulk`,
  qm_users_with_roles: `${serverPrefix}/adm/qm/user`,
  qm_users_with_roles_operator_set: `${serverPrefix}/adm/qm/user/operator_id`,
  qm_users_with_roles_role_set: `${serverPrefix}/adm/qm/user/role`,
  qm_manage_monitoring_forms_bulk: `${serverPrefix}/qm/mform/bulk`,
  qm_manage_monitoring_forms: `${serverPrefix}/qm/mform`,
  qm_manage_monitoring_forms_status: `${serverPrefix}/qm/mform/status`,
  qm_manage_monitoring_forms_clone: `${serverPrefix}/qm/mform/clone`,
  qm_manage_monitoring_forms_blocks_bulk: `${serverPrefix}/qm/mform/cblock/bulk`,
  qm_manage_monitoring_forms_blocks: `${serverPrefix}/qm/mform/cblock`,
  qm_manage_monitoring_forms_criteria_bulk: `${serverPrefix}/qm/mform/criterion/bulk`,
  qm_manage_monitoring_forms_criteria: `${serverPrefix}/qm/mform/criterion`,
  qm_manage_monitoring_forms_order: `${serverPrefix}/qm/mform/criterion/order`,
  qm_manage_monitoring_forms_block_order: `${serverPrefix}/qm/mform/cblock/order`,
  qm_manage_monitoring_forms_tasks_bulk: `${serverPrefix}/qm/mftask/bulk`,
  qm_manage_monitoring_forms_tasks: `${serverPrefix}/qm/mftask`,
  qm_manage_monitoring_forms_tasks_records_bulk: `${serverPrefix}/qm/mftask/mfs/bulk`,
  qm_manage_monitoring_forms_tasks_record: `${serverPrefix}/qm/mftask/mfs`,
  qm_manage_monitoring_forms_tasks_record_export: `${serverPrefix}/qm/mftask/mfs/export`,
  qm_manage_monitoring_forms_tasks_clone: `${serverPrefix}/qm/mftask/clone`,
  qm_manage_monitoring_forms_tasks_status: `${serverPrefix}/qm/mftask/status`,
  qm_manage_monitoring_forms_tasks_controllers: `${serverPrefix}/qm/mftask/controllers`,
  qm_statistic_monitoring_forms_list: `${serverPrefix}/qm/stat/mfs/bulk`,
  qm_statistic_monitoring_forms_list_export: `${serverPrefix}/qm/stat/mfs/bulk/export`,
  qm_statistic_widgets_bulk: `${serverPrefix}/qm/stat/widget/bulk`,
  qm_statistic_widgets: `${serverPrefix}/qm/stat/widget`,
  qm_statistic_operators: `${serverPrefix}/qm/stat/table/operators`,
  qm_statistic_teams: `${serverPrefix}/qm/stat/table/teams`,
  qm_appellations_bulk: `${serverPrefix}/qm/appellation/bulk`,
  qm_appellations: `${serverPrefix}/qm/appellation`,
  qm_appellations_status: `${serverPrefix}/qm/appellation/status`,
  qm_monitoring_operator_approve: `${serverPrefix}/qm/mftask/mfs/confirm`,
  qm_scale_template_bulk: `${serverPrefix}/qm/rs_template/bulk`,
  qm_scale_template: `${serverPrefix}/qm/rs_template`,
  AD_synchronization: `${serverPrefix}/adm/ad`,
  AD_synchronization_enable: `${serverPrefix}/adm/ad/enable`,
  AD_synchronization_disable: `${serverPrefix}/adm/ad/disable`,
  AD_synchronization_force: `${serverPrefix}/adm/ad/force`,
  sso_kerberos_auth: `${serverKerbPrefix}/sso/krb`,
  gpt_integration_all: `${serverPrefix}/gpt/integration/all/bulk`,
  gpt_integration_support: `${serverPrefix}/gpt/model_support/bulk`,
  gpt_integration_users: `${serverPrefix}/gpt/integration/bulk`,
  gpt_integration: `${serverPrefix}/gpt/integration`,
  gpt_integration_system_default_flag: `${serverPrefix}/gpt/integrations_default/is_default`,
  gpt_integration_billing: `${serverPrefix}/billing_gpt`,
  gpt_group_bulk: `${serverPrefix}/gpt/group/bulk`,
  gpt_chat_group_bulk: `${serverPrefix}/gpt_c/group/bulk`,
  gpt_group: `${serverPrefix}/gpt/group`,
  gpt_group_export: `${serverPrefix}/gpt/group/export`,
  gpt_group_import: `${serverPrefix}/gpt/group/import`,
  gpt_chat_group_export: `${serverPrefix}/gpt_c/group/export`,
  gpt_chat_group_import: `${serverPrefix}/gpt_c/group/import`,
  gpt_chat_group: `${serverPrefix}/gpt_c/group`,
  gpt_group_metrics_bulk: `${serverPrefix}/gpt/group/metric/bulk`,
  gpt_chat_group_metrics_bulk: `${serverPrefix}/gpt_c/group/metric/bulk`,
  gpt_group_metrics_calc_test: `${serverPrefix}/gpt/group/test/calc`,
  gpt_chat_group_metrics_calc_test: `${serverPrefix}/gpt_c/group/test/calc`,
  gpt_group_metrics_manual_recalc: `${serverPrefix}/gpt/group/calc`,
  gpt_chat_group_metrics_manual_recalc: `${serverPrefix}/gpt_c/group/calc`,
  metrics_recalculate: `${serverPrefix}/project/recalculate`,
  chat_metrics_recalculate: `${serverPrefix}/c_project/recalculate`,
  special_integration_keys: `${serverPrefix}/settings/afield`,
  export_ap_settings: `${serverPrefix}/project/export`,
  import_ap_settings: `${serverPrefix}/project/import`,
  export_chat_ap_settings: `${serverPrefix}/c_project/export`,
  import_chat_ap_settings: `${serverPrefix}/c_project/import`,
  dashboard_widget_bulk: `${serverPrefix}/dashboard/widget/bulk`,
  dashboard_widget: `${serverPrefix}/dashboard/widget`,
  dashboard_widget_layout: `${serverPrefix}/dashboard/widget/layout`,
};
export default serverRoutes;
